<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
    .register-value(v-if="value")
      a.link(:href="value" target="_blank" :style="styles")
        span.link-text(style="margin:0;") {{ value }}
    .register-value(v-else)
      span.error-message 未設定
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * リンクラベルのみコンポーネント
 *
 * - リンクと値を表示するのみ
 * - 入力要素コンポーネントと同じレイアウトをサポートする
 */
@Component
export default class FormLinkLabel extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: any;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    }
  })
  styles!: any;
}
</script>
